// extracted by mini-css-extract-plugin
export default {"auth":"Auth_auth__SyU75","control":"Auth_control__DlFSY"};